import React, { useEffect } from 'react';
import { bool, func, number, object } from 'prop-types';

import { VALIDATION_MESSAGE } from '../../../consts/validationMessage';
import { useFormErrors } from '../../hooks/useFormErrors';
import { CheckboxButton, CheckboxButtonGroup, FormLabel, InputLista, InputNumber, InputPercent, Modal, FormError } from '../../common';
import { useForm } from '@laramie/ui';
import { TIPO_COBERTURA_ANTICIPO } from '../../../consts/tipoCoberturaAnticipoType';
import { COBRO_ACCESORIOS_TYPE } from '../../../consts/cobroAccesoriosType';
import { TIPS } from '../../../consts/tips';

const PlanPagoDefinicionAnticipoCuotaModal = (props) => {

    //hooks
    const [formValues, formHandle, , formSet] = useForm(props.data.entity);

    useEffect(() => formSet(props.data.entity), [props.data.entity]);

    const muestraPorcentaje = formValues.tieneAnticipo && formValues.idTipoCoberturaAnticipo > 0 &&
        formValues.idTipoCoberturaAnticipo === TIPO_COBERTURA_ANTICIPO.PORCENTAJE_PLAN_PAGO;

    const { errorOf, validate } = useFormErrors(getErrors);

    //handles
    const handleTieneAnticipoChange = (event) => {
        formHandle(event);
        if (!event.target.value) formHandle({ target: { name: 'idTipoCoberturaAnticipo', type: 'lista', value: 0 } });
    };

    const handleClickAceptar = () => {
        if (!validate()) return;

        props.onConfirm({
            ...formValues,
            idTipoCoberturaAnticipo: formValues.tieneAnticipo ? formValues.idTipoCoberturaAnticipo : 0,
            porcentajeAnticipo: muestraPorcentaje ? formValues.porcentajeAnticipo : 0
        });
    };

    function getErrors() {
        const errors = {};

        if (!(formValues.cuotaDesde > 0)) errors.cuotaDesde = 'Ingresá un número mayor a cero';
        if (!(formValues.cuotaHasta > 0)) errors.cuotaHasta = 'Ingresá un número mayor a cero';
        if (formValues.tieneAnticipo && !(formValues.idTipoCoberturaAnticipo > 0)) errors.idTipoCoberturaAnticipo = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (muestraPorcentaje && !(formValues.porcentajeAnticipo > 0)) errors.porcentajeAnticipo = 'Ingresá un número mayor a cero';

        return errors;
    }

    return (
        <>

            <Modal
                size="lg"
                title="Anticipo"
                tipName={TIPS.NAME.MODALS.ANTICIPO_DEFINICION_MODAL}
                onEscape={() => props.onDismiss()}
                body={(
                            <div className="row">
                                <div className="col-12 col-md-4">
                                    <FormLabel htmlFor="cuotaDesde" required>Cuota desde</FormLabel>
                                    <InputNumber
                                        name="cuotaDesde"
                                        placeholder=""
                                        className={`form-control ${errorOf('cuotaDesde') ? 'is-invalid' : ''}`}
                                        value={formValues.cuotaDesde}
                                        onChange={formHandle}
                                        precision={0}
                                        disabled={props.disabled}
                                    />
                                    <FormError message={errorOf('cuotaDesde')} />
                                </div>
                                <div className="col-12 col-md-4">
                                    <FormLabel htmlFor="cuotaHasta" required>Cuota hasta</FormLabel>
                                    <InputNumber
                                        name="cuotaHasta"
                                        placeholder=""
                                        className={`form-control ${errorOf('cuotaHasta') ? 'is-invalid' : ''}`}
                                        value={formValues.cuotaHasta}
                                        onChange={formHandle}
                                        precision={0}
                                        disabled={props.disabled}
                                    />
                                    <FormError message={errorOf('cuotaHasta')} />
                                </div>
                                <div className="col-12 col-md-4">
                                    <CheckboxButtonGroup alignWithInputs>
                                        <CheckboxButton
                                            name="tieneAnticipo"
                                            label="Anticipo"
                                            checked={formValues.tieneAnticipo}
                                            onChange={handleTieneAnticipoChange}
                                            disabled={props.disabled}
                                        />
                                    </CheckboxButtonGroup>
                                </div>

                                {formValues.tieneAnticipo &&
                                <div className="col-12 col-md-8 m-top-10">
                                    <FormLabel htmlFor="idTipoCoberturaAnticipo" required>Cobertura anticipo</FormLabel>
                                    <InputLista
                                        name="idTipoCoberturaAnticipo"
                                        placeholder=""
                                        className={`form-control ${errorOf('idTipoCoberturaAnticipo') ? 'is-invalid' : ''}`}
                                        value={formValues.idTipoCoberturaAnticipo}
                                        onChange={formHandle}
                                        lista="TipoCoberturaAnticipo"
                                        filter={(row) => props.idTipoCobroAccesorios !== COBRO_ACCESORIOS_TYPE.DISTRIBUCION_PROPORCIONAL || row.id === TIPO_COBERTURA_ANTICIPO.PORCENTAJE_PLAN_PAGO}
                                        disabled={props.disabled}
                                    />
                                    <FormError message={errorOf('idTipoCoberturaAnticipo')} />
                                </div>
                                }
                                {muestraPorcentaje &&
                                <div className="col-12 col-md-2 m-top-10">
                                    <FormLabel htmlFor="porcentajeAnticipo" required>Porcentaje</FormLabel>
                                    <InputPercent
                                        name="porcentajeAnticipo"
                                        placeholder=""
                                        className={`form-control ${errorOf('porcentajeAnticipo') ? 'is-invalid' : ''}`}
                                        value={formValues.porcentajeAnticipo}
                                        onChange={formHandle}
                                        disabled={props.disabled}
                                    />
                                    <FormError message={errorOf('porcentajeAnticipo')} />
                                </div>
                                }
                            </div>
                )}
                footer={!props.disabled ? (<>
                                <button className="btn btn-outline-primary" data-dismiss="modal" onClick={() => props.onDismiss()}>Cancelar</button>
                                <button className="btn btn-primary" data-dismiss="modal" onClick={() => handleClickAceptar()}>Aceptar</button>
                </>) : (
                                <button className="btn back-button" data-dismiss="modal" onClick={() => props.onDismiss()}>Volver</button>
                )}
                footerClassName={props.disabled ? 'f-align' : ''}
            />

        </>
    );
}

PlanPagoDefinicionAnticipoCuotaModal.propTypes = {
    disabled: bool,
    data: object.isRequired,
    idTipoCobroAccesorios: number,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired,
};

PlanPagoDefinicionAnticipoCuotaModal.defaultProps = {
    disabled: false,
    idTipoCobroAccesorios: 0
};

export default PlanPagoDefinicionAnticipoCuotaModal;
